export type NumberInputValue = number | undefined;

export function isValidInput(min: NumberInputValue, max: NumberInputValue): boolean {
  if (min == null || max == null) {
    return false;
  }

  return min > max;
}
